export const EVENT_NAME = 'ubc_tag';

export const EVENT_TYPE_VIEW = 'view';
export const EVENT_TYPE_CLK = 'clk';

export const SERVICE_ID = 12865;
